// extracted by mini-css-extract-plugin
export default {"articleTitle":"companyStructure_articleTitle__POgQ7","pictureContainer":"companyStructure_pictureContainer__6Onfu"};